<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Nepalese Arrival/Departure Country Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="nepalese-arrival-departure-countrywise" :export-country="country"
                                        :export-date="range"
                                        v-if="$oauth.checkIfHasPermission(['export nepalese-arrival-departure-summary-report'])"/>
          <refresh-button :click-function="updateByCountry"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs6 class="d-flex align-center">
              <custom-date-range-picker @change="updateByCountry"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="country"
                  @change="updateByCountry"
              />
            </v-flex>
          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th>Country Name</th>
                <th class="text-center">Arrived</th>
                <th class="text-center">Departed</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="country_wise_data.length">
              <tr v-for="(item,i) in country_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.country_name }}</td>
                <td class="text-center">{{ item.arrived }}</td>
                <td class="text-center">{{ item.departed }}</td>
                <td class="text-center font-weight-bold">{{ item.arrived + item.departed }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_arrived }}</td>
                <td class="text-center">{{ total_departed }}</td>
                <td class="text-center">{{ total_totalAD }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const AD_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/nepalese-arrival-departure-countrywise`;

export default {
  name: "ADCountryWiseReport",
  data() {
    return {
      country_wise_data: [],
      range: {},
      country: [],
      table_data: [],
      total_arrived: 0,
      total_departed: 0,
      total_totalAD: 0
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      countries: "CountryList/all",
    }),
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
    }),
    updateByCountry() {
      let params = {};
      this.progressLinearLoading = true;
      if (this.range)
        params.date_range = this.range;
      if (this.country)
        params.country = this.country;
      this.total_arrived = 0;
      this.total_departed = 0;
      this.total_totalAD = 0;
      Http.get(AD_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.country_wise_data = res.data.data;
            this.country_wise_data.forEach(item => {
              this.total_arrived += item.arrived;
              this.total_departed += item.departed;
            })
            this.total_totalAD += this.total_arrived + this.total_departed
            this.progressLinearLoading = false;
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    if (this.$store.state.CountryList.all.length === 0) {
      this.fetchCountries();
    }
    this.progressLinearLoading = true;
    Http.get(AD_SUMMARY_REPORT_URL)
        .then((res) => {
          this.country_wise_data = res.data.data;
          this.country_wise_data.forEach(item => {
            this.total_arrived += item.arrived;
            this.total_departed += item.departed;
          })
          this.total_totalAD += this.total_arrived + this.total_departed
          this.progressLinearLoading = false;

        })
        .catch(() => {
          this.progressLinearLoading = false;
        });
    if (this.$store.state.OfficeList.offices.length === 0) {
      this.$store.dispatch("OfficeList/fetchData");
    }

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>

